import axios from 'axios';

export default function getFeatureInfo(url) {
  let params = {};
  return axios
    .get(url, {
      params: params,
    })
    .then(response => {
      return response.data.features;
    });
}



// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/services/getFeatureInfo.js